<script>
import DefaultMixin from '../mixin'
import RequerAtencao from "components/fenaju/components/dashboard/RequerAtencao.vue"
import Stats from "components/fenaju/components/dashboard/Stats.vue"
// import Leitor from "components/fenaju/components/dashboard/Leitor.vue"
// import Resumo from "components/fenaju/components/dashboard/Resumo.vue"
import ClientesOs from "components/fenaju/components/clientes/dashboard/OrdemServico.vue";

export default {
  name: 'FenajuDashboard',
  provide: function () {
    return {
      container: this
    }
  },
  mixins: [DefaultMixin],
  components: {
    ClientesOs,
    //Resumo,
    //Leitor,
    Stats,
    RequerAtencao,
  },
  data() {
    return {
      menuActive: 'suporte'
    }
  },
  computed: {
  },
  beforeMount () {
  },
  watch: {
  },
  mounted() {
    document.body.classList.add('console-clientes-dashboard')
  },
  destroyed() {
    document.body.classList.remove('console-clientes-dashboard')
  },
  methods: {
  },
  meta: {
    title: 'Console',
    name: 'Console'
  }
}
</script>

<template>
    <div class="console-dashboard">
<!--      <div class="console-dash-menu-container">
        <div class="console-dash-menu console-dash-menu-level1" :class="{maxWidth: $route.name === 'fenaju.registros'}">
          <u-btn @click="$router.push({name: 'fenaju.registros'})" class="opt-btn" :class="{active: $route.name === 'fenaju.registros'}"><i class="fa-duotone fa-chart-bar" /> Dashboard</u-btn>
          <u-btn @click="$router.push({name: 'fenaju.registros.lista'})" class="opt-btn" :class="{active: $route.name === 'fenaju.registros.lista'}"><i class="fal fa-square-list" /> Lista</u-btn>
        </div>
      </div>-->
      <div v-show="$route.name === 'fenaju.registros'" class="ev2-body">
        <div class="content-limit">
          <div class="content flex">
            <clientes-os />
            <requer-atencao />
            <stats />
          </div>
<!--          <div class="content flex">
            <leitor />
            <resumo />
          </div>-->
        </div>
      </div>
      <router-view />
    </div>
</template>

<style lang="stylus">
.console-dash-menu.maxWidth {
  max-width 1440px
}
</style>
